const styles = (theme) => ({
    contentPaper: {
        maxWidth: 650,
    },
    content: {
        paddingLeft: 75,
        paddingRight: 75,
    },
    contentText: {
        color: theme.palette.primary.main,
    },
    text: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    moreText: {
        fontSize: 10,
    },
    title: {
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        marginBottom: 20,
        fontSize: 24,
        fontWeight: 'bold',
    },
    button: {
        width: 130,
    },
});

export default styles;
